import { endPointOryton, endpointMail } from './base.config';

export const oryton = {
  getCompanyByUserId: `${endPointOryton}/api/subscriptions/products/1`, // 1 = Oryton
  fetchEmailForward: `${endpointMail}/api/mail-bilagsky/forward`,
  addEmailForward: `${endpointMail}/api/mail-bilagsky/forward`,
  removeEmailForward: `${endpointMail}/api/mail-bilagsky/forward/:uuid`,
  getInbox: `${endpointMail}/api/mail-bilagsky/inbox`,
  getInboxDetail: `${endpointMail}/api/mail-bilagsky/inbox/:uuid`,
  readInbox: `${endpointMail}/api/mail-bilagsky/inbox/:uuid`,
  listUsers: `${endPointOryton}/ajax/users/list`,
  listAccountants: `${endPointOryton}/ajax/users/types/accountants`,
  getMenuServices: `${endPointOryton}/ajax/settings/MenuService`,
  getCompanyStartEnd: `${endPointOryton}/api/companies/start_end`,
  getCompany: `${endPointOryton}/api/companies/:id/detail`,
  findUser: `${endPointOryton}/api/users/list/search`,
  fetchUser: `${endPointOryton}/api/kpi-target-setting`,
  getFikenCompany: `${endPointOryton}/api/3rd/fiken/company/:companyId`,
  getCompanyStripeCards: `${endPointOryton}/api/3rd/stripe/companies/:companyId/cards`,
  getTripletexCompany: `${endPointOryton}/api/3rd/tripletex/resource/:companyId`,
  // accounting invitation
  getAccountingInvitation: `${endPointOryton}/api/accounting-companies/invitations/:orgnr`,
  updateAccountingInvitation: `${endPointOryton}/api/accounting-companies/:accountingCompanyId/invitations/:orgnr/response`,
};
